module.exports = __webpack_public_path__ + "static/media/arrow.25918ee1.svg";